





import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import MortgageForm from '@/components/modules/App/CalculatorComponent/CalculatorForm.vue'

interface Data {}

interface Methods {}

interface Computed {}

interface Props {}

export default Vue.extend({
  name: 'InstallmentTab',
  components: {
    MortgageForm
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
